import gsap from 'gsap';

const imageFloater = document.querySelector('.c-image-floater');

/**
 * Make the floater follow the mouse movement and scroll position
 * https://codepen.io/GreenSock/pen/xxpbORN?editors=0010
 */

const floaterMove = () => {

    if(!imageFloater) return;

    gsap.set(imageFloater, {xPercent: -50, yPercent: -50});

    let xTo = gsap.quickTo(imageFloater, 'x', {duration: 0.75, ease: 'power4.out'});
    let yTo = gsap.quickTo(imageFloater, 'y', {duration: 0.75, ease: 'power4.out'});

    window.addEventListener('mousemove', e => {
        xTo(e.clientX);
        yTo(e.clientY);
    });
    window.addEventListener('pointermove', e => {
        xTo(e.clientX);
        yTo(e.clientY);
    });

}

/**
 * Show the floater
 */

const floaterShow = () => {

    gsap.to(imageFloater, {
        scale: 1,
        autoAlpha: 1,
        duration: 0.2
    });

}

/**
 * Hide the floater
 */

const floaterHide = () => {

    gsap.to(imageFloater, {
        scale: 0.1,
        autoAlpha: 0,
        duration: 0.2
    });

}

/**
 * Show and hide the floater when hovering an element
 */

const floaterShowHide = () => {

    const floaterTrigger = document.querySelectorAll('[data-image-floater]');
    if(!floaterTrigger) return;

    floaterTrigger.forEach(element => {    
        element.addEventListener('mouseenter', floaterShow);
        element.addEventListener('mouseleave', floaterHide);
    });

}

const handleImageFloater = () => {

    if(!imageFloater) return;

    const triggers = document.querySelectorAll('.c-thumb-inline');
    const count = triggers.length;

    triggers.forEach((trigger, index) => {
        trigger.addEventListener('mouseenter', () => {
            gsap.to('.c-image-floater__wrap', {
                y: (index*100)/(count*-1) + "%",
                duration: 1,
                ease: 'power4.out'
            })
        });
    });

}

export { floaterMove, floaterShowHide, handleImageFloater }